import type { Translations } from './types';

const pt: Translations = {
    next: 'Próximo',
    storyReadPrompt: 'Por favor, lê primeiro a história.',
    backToStory: '← Voltar à história',
    nextArrow: 'Próximo →',
    finishAssessment: 'Terminar avaliação →',
    common_step: 'Passo',
    questionsStory1: 'Perguntas — História 1',
    questionsStory2: 'Perguntas — História 2',
    lastSetOfQuestions: 'Últimas perguntas — quase a terminar! 🎉',
    typeAnswerHere: 'Escreve a tua resposta aqui...',
    backCountSingular: '📖 Voltaste {n} vez a esta página para reler a história.',
    backCountPlural: '📖 Voltaste {n} vezes a esta página para reler a história.',

    assessmentComplete: 'Avaliação Concluída! 🎉',
    assessmentSubtitle: 'Deste um passo importante para compreender as diferenças de aprendizagem',
    returnToHome: 'Voltar ao Início',
    assessmentSuccessfullyCompleted: 'Avaliação Concluída com Sucesso',
    amazingJob: 'Excelente Trabalho!',
    youCrushedIt: 'Conseguiste! Aqui está o que alcançaste:',
    whatsNext: 'O que vem a seguir?',
    getReadyForResults: 'Prepara-te para os teus resultados personalizados',
    youDidIt: 'Conseguiste!',
    youDidItDesc:
      'O teu empenho em compreender as diferenças de aprendizagem é verdadeiramente inspirador. Enquanto outros poderiam ter desistido, tu foste até ao fim!',

    heroLine1: 'DISLEXIA',
    heroLine2: 'RASTREIO',
    heroTagline: 'numa só sessão',
    heroSubtitle:
      'Uma avaliação multimodal no navegador que te dá um relatório escrito assim que terminas — sem ida à clínica, sem lista de espera, sem equipamento especial.',
    heroBetaLabel: 'BETA',
    startAssessment: 'Começar',
    trustedBy: 'Escolhido por educadores e investigadores em todo o mundo',

    pfp_privacyBadge: 'Privacidade e Conformidade',
    pfp_privacyHeading: 'Levamos a proteção de dados a sério com total conformidade GDPR e MDR',
    pfp_formBadge: 'Inicia a Tua Avaliação',
    pfp_ctaHeading: 'RASTREIO DE DISLEXIA',
    pfp_ctaDesc: 'Junta-te a milhares de pessoas que descobriram informações únicas sobre o seu estilo de leitura através da nossa avaliação baseada em inteligência artificial.',
    pfp_ctaFooter: 'Sem limite de tempo • Ao teu ritmo • 100% confidencial',
    pfp_whyTitle: 'Porquê a DysTest?',
    pfp_whySubtitle: 'Descobre o que torna a nossa avaliação baseada em IA a solução mais precisa e fiável',
    pfp_whyDesc: 'A DysTest combina mais de 20 anos de experiência profissional em investigação sobre dislexia com uma vida de experiência vivida. Ao fazer engenharia reversa de como os leitores disléxicos e neurotípicos processam o texto, a nossa IA aprende a distinguir padrões de leitura subtis que os testes tradicionais não detetam.',
    pfp_feature1Title: 'Rastreamento ocular, dinâmica de teclado e análise multilingue',
    pfp_feature1Desc: 'A IA avançada analisa movimentos oculares, expressões faciais e teclas pressionadas para revelar padrões de aprendizagem únicos para cada leitor — em qualquer língua. A DysTest adapta-se de forma inteligente a utilizadores multilingues para uma compreensão precisa e personalizada.',
    pfp_feature2Title: 'Resultados Imediatos e Úteis',
    pfp_feature2Desc: 'Obtém informações claras e fundamentadas cientificamente em minutos. Os nossos relatórios traduzem dados complexos em recomendações fáceis de entender que ajudam pais, educadores e estudantes.',
    pfp_feature3Title: 'Privacidade e Conformidade em Primeiro Lugar',
    pfp_feature3Desc: 'Os teus dados são encriptados, anonimizados e tratados segundo os mais elevados padrões éticos e regulatórios — totalmente conformes com o GDPR e o MDR. Nada é partilhado ou usado para além de melhorar a tua experiência DysTest.',
    pfp_feature4Title: 'Design Acessível e Centrado no Ser Humano',
    pfp_feature4Desc: 'A DysTest permite-te fazer o rastreio ao teu ritmo — calmo, intuitivo e sem pressão. Concebida para a inclusividade, acessibilidade e compreensão significativa, redefine como as diferenças de aprendizagem são descobertas e apoiadas.',
    pfp_finalCtaDesc: 'Começa hoje o teu rastreio de dislexia personalizado baseado em IA — concebido para compreender como lês, não apenas o que lês.',

    hiw_badge: 'Processo Simples em 8 Passos',
    hiw_heading: 'Como Funciona a Avaliação',
    hiw_subtext: 'Do registo a um relatório detalhado de rastreio de dislexia — inteiramente no browser, sem downloads necessários.',
    hiw_step1Title: 'Regista-te',
    hiw_step1Desc: 'Introduz o teu nome, idade e língua preferida. Sem conta necessária — demora menos de 2 minutos.',
    hiw_step2Title: 'Calibra os Olhos',
    hiw_step2Desc: 'Segue 16 pontos animados no ecrã. O rastreador de íris IA aprende a tua assinatura visual única.',
    hiw_step3Title: 'Palavras & Imagens',
    hiw_step3Desc: 'Associa palavras às suas imagens enquanto medimos a velocidade de reconhecimento e o processamento visuo-fonológico.',
    hiw_step4Title: 'Teste de velocidade RAN',
    hiw_step4Desc: 'Nomeia em voz alta uma sequência de cores ou objetos o mais rápido possível. Mede a fluidez de recuperação.',
    hiw_step5Title: 'Histórias & Perguntas',
    hiw_step5Desc: 'Lê duas histórias adequadas à idade e responde a perguntas de compreensão. Os movimentos oculares e o pestanejar são registados.',
    hiw_step6Title: 'Escrita de palavras',
    hiw_step6Desc: 'Digita palavras de memória. Os tempos de digitação e os padrões de erro revelam o processamento ortográfico e motor.',
    hiw_step7Title: 'Feedback',
    hiw_step7Desc: 'Partilha a tua experiência e preocupações. Este contexto ajuda a calibrar a interpretação clínica.',
    hiw_step8Title: 'Obtém os Resultados',
    hiw_step8Desc: 'Recebe um relatório detalhado com indicadores de risco de dislexia, mapas de calor do olhar e métricas de leitura.',

    pf_whoTaking: 'Quem vai fazer o teste?',
    pf_myself: 'Eu próprio',
    pf_myselfAge: 'Idade 13+',
    pf_child: 'O meu filho',
    pf_childAgeRange: 'Idade 5-12',
    pf_verifyEmailTitle: 'Verifica o teu Email',
    pf_parentalConsentStepTitle: 'Consentimento Parental',
    pf_verifyEmailDesc: 'Introduz o código enviado para o teu email para completar o registo',
    pf_consentDesc: 'Por favor revê e fornece consentimento para o tratamento de dados',
    pf_yourName: 'Nome do participante *',
    pf_yourNamePlaceholder: 'Introduz o teu nome completo',
    pf_emailAddress: 'Endereço de Email *',
    pf_assessmentLanguage: 'Idioma da avaliação',
    pf_emailPlaceholder: 'Introduz o teu email',
    pf_invalidEmail: 'Por favor introduz um endereço de email válido',
    pf_yourAge: 'A tua Idade *',
    pf_selectAge: 'Seleciona o grupo etário',
    pf_yearsUnit: 'anos',
    pf_dyslexiaTested: 'Já foste testado para dislexia?',
    pf_iAmDyslexic: 'Sim, estou diagnosticado oficialmente',
    pf_iAmNotDyslexic: 'Testado e não disléxico',
    pf_notKnown: 'Não testado',
    pf_parentName: 'Nome do Encarregado de Educação *',
    pf_parentNamePlaceholder: 'Introduz o nome do encarregado de educação',
    pf_childName: 'Nome da Criança *',
    pf_childNamePlaceholder: 'Introduz o nome da criança',
    pf_childAgeLabel: 'Idade da Criança *',
    pf_selectChildAge: 'Seleciona o grupo etário',
    pf_childDyslexiaTested: 'O teu filho já foi testado para dislexia?',
    pf_yesHasDyslexia: 'Sim, diagnosticado oficialmente',
    pf_yesNoDyslexia: 'Testado e não disléxico',
    pf_noNotTested: 'Não, nunca foi testado',
    pf_nativeLangQuestion: 'Que idioma fala em casa?',
    pf_browserLangDetected: 'Língua do browser detetada:',
    pf_availableInSystem: '✓ Disponível no nosso sistema',
    pf_yesNative: 'Sim',
    pf_othersNative: 'Outros',
    pf_specifyNative: 'Especifica a tua língua materna *',
    pf_selectNativePlaceholder: 'Seleciona a tua língua materna',
    pf_selectNativeError: 'Por favor seleciona a tua língua materna',
    pf_nativeLangNote: 'Isto ajuda-nos a fornecer resultados de avaliação mais precisos com base no teu contexto linguístico. A língua do teu browser ({lang}) foi detetada automaticamente — nunca usamos o teu endereço IP para deteção de língua.',
    pf_forYourChild: 'Para o Teu Filho',
    pf_childExplanation: 'O computador vê como lês — o teu rosto, olhos e como escreves — para perceber o teu estilo de leitura. Nada de mau acontece aos teus dados. O teu pai ou mãe disse que está bem, e podes parar quando quiseres.',
    pf_parentalConsentLabel: 'Consentimento Parental *',
    pf_parentalConsentText: 'Consinto no tratamento dos dados faciais, de movimento ocular e de interação com o teclado do meu filho (ou meus) para rastreio de dislexia e avaliação de aprendizagem em conformidade com o GDPR e o MDR.',
    pf_dataConsentLabel: 'Consentimento de Tratamento de Dados e Política de Privacidade *',
    pf_dataConsentText: 'Concordo com o tratamento dos meus dados pessoais para fins de rastreio.\nLi e concordo com a Política de Privacidade e os Termos de Serviço.',
    pf_consentPre: 'Concordo com a',
    pf_consentPrivacyLink: 'Política de Privacidade',
    pf_consentBetween: 'e os',
    pf_consentTermsLink: 'Termos de Serviço',
    pf_consentPost: ', incluindo o tratamento de dados para fins de rastreio.',
    pf_emailFailedTitle: 'Falha no Envio do Email',
    pf_checkYourEmail: 'Verifica o teu Email',
    pf_emailSentDesc: 'Enviámos um código de verificação de 6 dígitos para {email}. Por favor verifica a tua caixa de entrada e introduz o código abaixo.',
    pf_emailFailedDesc: 'Falha no envio para {email}.',
    pf_tryAgain: 'Tenta de Novo',
    pf_sendingEmail: 'A enviar...',
    pf_verificationCodeLabel: 'Código de Verificação *',
    pf_enterCodePlaceholder: 'INTRODUZ CÓDIGO DE 6 DÍGITOS',
    pf_codeExpiry: 'Introduz o código de 6 dígitos do teu email. O código expira em 15 minutos.',
    pf_resendCode: 'Não recebeste o código? Clica para reenviar',
    pf_sendingNewCode: 'A enviar novo código...',
    pf_continue: 'Continuar',
    pf_continueToConsent: 'Continuar para o Consentimento',
    pf_verifyEmailBtn: 'Verificar Email',
    pf_verifying: 'A verificar...',
    pf_processing: 'A processar...',
    pf_importantNotice: 'Aviso Importante',
    pf_disclaimer: 'A DysTest é uma ferramenta digital de rastreio concebida para apoiar a deteção precoce e informações sobre aprendizagem. Não fornece um diagnóstico médico. Para um diagnóstico oficial ou conselho clínico, por favor consulta profissionais de saúde qualificados.',

            cg_readingAssessment: 'Avaliação de leitura',
    cg_whatsNext: 'O que vem a seguir',
    cg_twoSections: 'Duas secções curtas — lê uma história e depois responde a algumas perguntas',
    cg_readStory: 'Lê a história',
    cg_readStoryDesc: 'Toma o teu tempo — lê ao teu ritmo',
    cg_answerQuestions: 'Responde a algumas perguntas',
    cg_answerQuestionsDesc: 'Escreve as tuas respostas com as tuas próprias palavras — não há certo ou errado',
    cg_exampleQuestion: 'O que aconteceu no início da história?',
    cg_exampleAnswer: 'O rapaz foi ao parque…',
    cg_startReading: 'Começar a ler',
    cg_warmupGame: 'Jogo de aquecimento',
    cg_matchHeading: 'Associa a palavra à imagem',
    cg_matchSubtitle: 'Clica num cartão de palavra e depois na imagem correspondente para completar o par',
    cg_startMatching: 'Começar!',
    cg_demoWord: 'gato',
    cg_allMatched: 'Todos os pares correspondidos!',
    cg_heatmapContinuing: 'O teu mapa de calor do olhar é mostrado abaixo — a continuar em breve…',
    cg_lookAtTarget: '👁️ A olhar para o alvo!',
    cg_lookAtDot: 'Olha para o ponto vermelho',
    cg_sRemaining: 's restantes',
    cg_skipFixation: 'Saltar Fixação',
    cg_correct: '✓ Correto!',
    cg_tryAgain: '✗ Tenta de Novo',
    cg_liveMetrics: 'Métricas ao Vivo',
    cg_blinks: 'Pestanejo',
    cg_matched: 'Correspondidos',
    cg_errors: 'Erros',

    fpc_instruction: 'Olha para cada ponto',
    fpc_dotsTotal: 'pontos no total — olha diretamente para cada ponto e mantém o olhar. Captura automaticamente.',
    fpc_cancelCalibration: 'Cancelar calibração',
    fpc_clickMe: 'Clica aqui!',
    fpc_eyeTrackingStarting: 'Rastreamento ocular a iniciar — já podes clicar!',
    fpc_calibrationComplete: 'Calibração Concluída!',
    fpc_trainingSamples: '{n} amostras de treino registadas',
    fpc_allPointsDone: 'Todos os pontos concluídos!',
    fpc_pointOf: 'Ponto {current} de {total}',
    fpc_training: 'Treino',
    fpc_inactive: 'Calibration inactive',
    fpc_savingCalibration: 'A guardar calibração…',
    fpc_moveEyes: 'Move os olhos para o ponto…',
    fpc_noFace: '⚠️ Nenhum rosto detetado — centra o rosto na câmara',
    fpc_missingIrisTitle: '⚠️ Dados da íris ausentes em demasiados pontos',
    fpc_missingIrisBody: 'Vários pontos de calibração foram ignorados porque os pontos de referência da íris não foram detectados.',
    fpc_lowAccuracyTitle: 'Precisão inferior ao esperado',
    fpc_lowAccuracyBody: 'O erro de calibração é superior ao ideal. Isto pode reduzir a precisão do rastreamento ocular.',
    fpc_redoCalibration: 'Refazer calibração',
    fpc_continueAnyway: 'Continuar mesmo assim',
    fpc_lookAtDot: 'Olha diretamente para o ponto',
    fpc_dotReady: '✓ Ponto capturado — a avançar…',
    fpc_keepLooking: 'Continua a olhar para o ponto — captura automaticamente',
    fpc_captured: '✓ Capturado! A avançar para o próximo…',
    fpc_checkingAccuracy: 'A verificar precisão',
    fpc_valGotIt: 'Obtido! A avançar para o próximo…',
    fpc_valHoldStill: 'Fica quieto — a recolher dados…',
    fpc_valLookDot: 'Olha para o ponto — fica laranja quando está pronto',
    fpc_valCheck: 'VER',

    acp_welcome: 'Bem-vindo, {name}!',
    acp_setupSubtitle: 'Vamos configurar a tua avaliação',
    acp_setupVerification: 'Verificação de Configuração',
    acp_setupStepsDesc: 'Conclui todos os passos para desbloquear a avaliação',
    acp_step1Title: 'Câmara Ativa',
    acp_step1Desc: 'A câmara inicia automaticamente — nenhuma ação necessária',
    acp_step2Title: 'Verificação de Câmara',
    acp_step2Desc: 'Verifica a qualidade e estabilidade da câmara',
    acp_step3Title: 'Teste de Digitação',
    acp_step3Desc: 'Verifica o funcionamento do teclado',
    acp_step4Title: 'Calibração Ocular',
    acp_step4Desc: 'Calibra o sistema de rastreamento ocular',
    acp_eyeTrackingActive: '✓ Rastreamento ocular ativo',
    acp_eyeTrackingError: '⚠ Erro de rastreamento ocular:',
    acp_startingEyeTracking: '⏳ A iniciar rastreamento ocular...',
    acp_cameraReady: '👁 Câmara pronta',
    acp_waitingForCamera: '📷 Câmara a iniciar automaticamente...',
    acp_stepDone: 'Concluído',
    acp_stepInProgress: 'Em Curso',
    acp_checkingCameraStability: 'A verificar estabilidade da câmara...',
    acp_cameraVerified: 'Câmara Verificada ✓',
    acp_autoVerifyingCamera: 'A verificar câmara automaticamente...',
    acp_waitingFaceDetection: 'À espera de deteção de rosto...',
    acp_eyeTrackingStarting: 'A iniciar rastreamento ocular...',
    acp_calibrationInProgress: 'Calibração em curso...',
    acp_eyeTrackingReady: 'Rastreamento Ocular Pronto ✓',
    acp_startingCalibration: 'A iniciar calibração...',
    acp_distanceHint: 'Mantém o rosto ao centro e imóvel, a não mais de 60 cm do ecrã',
    acp_distanceLabel: 'máx. 60 cm',
    acp_fpsTitle: 'A tua câmara está um pouco lenta',
    acp_fpsBody: 'Fornece {fps} imagens por segundo; são necessárias pelo menos 10 para medir o olhar. Isto costuma ajudar em segundos:',
    acp_fpsVeryLow: 'A esta velocidade, algumas medidas dos movimentos dos olhos podem não ser utilizáveis; as outras tarefas continuam a contar.',
    acp_fpsTipLight: 'Acende mais luz ou vira o rosto para uma janela',
    acp_fpsTipCharger: 'Liga o carregador (a poupança de bateria torna o portátil mais lento)',
    acp_fpsTipApps: 'Fecha videochamadas e outros programas pesados',
    acp_fpsCheckAgain: 'Verificar novamente',
    acp_fpsChecking: 'A verificar…',
    acp_fpsContinue: 'Continuar mesmo assim',
    acp_preparingEyeTracking: 'A preparar rastreamento ocular...',
    acp_cameraPreview: 'Pré-visualização da Câmara',
    acp_noFaceDetected: 'Nenhum rosto detetado',
    acp_live: 'AO VIVO',
    acp_cameraVerifiedTitle: 'Câmara Verificada ✓',
    acp_cameraReadyTitle: 'Câmara Pronta',
    acp_qualityCheckPassed: 'Verificação de qualidade aprovada',
    acp_optimizedForAssessment: 'Otimizada para avaliação',
    acp_verifiedBadge: 'Verificada',
    acp_readyBadge: 'Pronta',
    acp_assessmentMetrics: 'Métricas de Avaliação',
    acp_faceDistance: 'Distância do Rosto',
    acp_goodDistance: 'Boa distância para avaliação',
    acp_searching: 'A procurar...',
    acp_lightLevel: 'Nível de Luz',
    acp_fps: 'FPS',
    acp_fpsExcellent: 'Taxa de fotogramas excelente',
    acp_fpsGood: 'Boa taxa de fotogramas',
    acp_fpsModerate: 'Taxa de fotogramas moderada',
    acp_fpsLow: 'Taxa de fotogramas baixa',
    acp_fpsInitializing: 'A inicializar...',
    acp_faceDetection: 'Deteção de Rosto',
    acp_faceDetected: '✓ Detetado',
    acp_faceDetectedSub: 'Rosto detetado com sucesso',
    acp_cameraQualityPassed: 'Verificação de qualidade da câmara aprovada. Pronto para o próximo passo.',
    acp_visionWarnings: 'Avisos Visuais',
    acp_trackingMetrics: 'Métricas de Rastreamento',
    acp_headPitch: 'Inclinação da Cabeça:',
    acp_headYaw: 'Rotação da Cabeça:',
    acp_headRoll: 'Rolamento da Cabeça:',
    acp_gazePoint: 'Ponto de Olhar:',
    acp_emotion: 'Emoção:',
    acp_confidence: 'Confiança:',
    acp_trackingId: 'ID de Rastreamento:',
    acp_faceId: 'ID do Rosto:',
    acp_browser: 'Browser:',
    acp_os: 'SO:',
    acp_camera: 'Câmara:',
    acp_resolution: 'Resolução:',
    acp_initializingTracking: 'A inicializar métricas de rastreamento...',
    acp_dataQuality: 'Qualidade dos Dados',
    acp_dataQualityExcellent: 'EXCELENTE',
    acp_dataQualityGood: 'BOA',
    acp_dataQualityFair: 'RAZOÁVEL',
    acp_dataQualityDetecting: 'A DETETAR...',
    acp_dataQualityExcellentDesc: 'Ideal para avaliação',
    acp_dataQualityGoodDesc: 'Boa para avaliação',
    acp_dataQualityFairDesc: 'Qualidade aceitável',
    acp_dataQualityDetectingDesc: 'A analisar condições',
    acp_faceMeshPoints: 'Pontos de Malha Facial',
    acp_completeFaceMesh: 'Malha facial completa',
    acp_detecting: 'A detetar...',
    acp_typingTest: 'Teste de Digitação',
    acp_typeQwerty: 'Escreve {target} para verificar o teclado',
    acp_verifyKeyboard: 'Verifica o funcionamento do teclado',
    acp_activeStatus: 'Ativo',
    acp_lockedStatus: 'Bloqueado',
    acp_typeHere: 'Escreve aqui...',
    acp_typingCompleted: '✓ Concluído! A avançar para o próximo passo...',
    acp_keepTyping: 'Continua a escrever:',
    acp_remaining: 'restantes',
    acp_startTyping: 'Começa a escrever as letras acima',
    acp_completeCameraVerification: 'Conclui a verificação da câmara para desbloquear',
    acp_lightingPerfect: 'Iluminação perfeita para avaliação',
    acp_lightingSlightlyBright: 'Ligeiramente brilhante - reduz se possível',
    acp_lightingTooBright: 'Demasiado brilhante - reduz iluminação/brilho do ecrã',
    acp_lightingSlightlyDim: 'Ligeiramente escuro - aumenta se possível',
    acp_lightingTooDim: 'Demasiado escuro - aumenta iluminação',
    acp_positionFace: '👤 Posiciona o rosto no campo de visão da câmara',
    acp_faceDetectedStarting: '✅ Rosto detetado - a iniciar verificação...',
    acp_adjustDistance: 'Ajusta a tua distância da câmara',
    acp_moveFarther: 'Afasta-te da câmara',
    acp_distanceInRange: 'A distância está boa',
    pdg_moveCloser: 'Aproxima-te da câmara',
    pdg_moveFarther: 'Afasta-te da câmara',
    pdg_dismiss: 'Ignorar',
    acp_noData: 'Sem dados',
    acp_setupProgress: 'Progresso de Configuração',
    acp_stepsComplete: '{n} de 4 passos concluídos',
    acp_environment: 'Ambiente',
    acp_checkingEllipsis: 'A verificar…',
    acp_waitingEllipsis: 'À espera…',
    acp_analysingConditions: 'A analisar condições da câmara…',
    acp_positionFaceCamera: 'Posiciona o rosto na câmara',
    acp_faceAligned: 'Rosto alinhado',
    shared_stepOf: 'Passo {step} de {total}',
    shared_start: 'iniciar',
    cal_introHeading: 'CALIBRAÇÃO',
    cal_introSubtitle: 'Siga os pontos e mantenha a cabeça imóvel',
    story_introHeading: 'LEITURA E PERGUNTAS',
    fpc_lookHere: '👆 Clica no ponto para continuar',
            pfp_chip_gdpr: 'Conforme RGPD',
    pfp_chip_mdr: 'Alinhado MDR',
    pfp_chip_noData: 'Sem partilha de dados',
    pfp_chip_languages: '8 Idiomas',
    kbv_header: 'Captura de dinâmica de teclado',
    kbv_interKey: 'Intervalo entre teclas',
    kbv_typingSpeed: 'Velocidade de digitação',
        pfp_aiBadge: 'Ferramenta de rastreio de dislexia com rastreamento ocular',
    pfp_whyBadge: 'Por que DysTest',
    mat_missionBadge: 'A nossa missão e tecnologia',
    mat_eyeBadge: 'Rastreamento ocular',
    mat_kbdBadge: 'Análise de teclas',
    mat_ferBadge: 'Expressão facial',
    pfp_noBrowserFooter: 'Sem conta necessária · Totalmente no browser · Resultados em <15 minutos',
    eye_viz_landmarks: '478 Pontos-chave',
    eye_viz_irisFaceMesh: 'Íris + Malha facial',
    eye_viz_fps: '30 FPS em tempo real',
    eye_viz_validation: 'Validação 9 + 4 pontos',
    eye_viz_calibration: 'Calibração clínica de 13 pontos',
    ran_anim_rapidNaming: 'Nomeação rápida',
    ran_anim_predictor: '#1 indicador de dislexia',
    ran_anim_ageNormed: 'Pontuação por idade',
    ran_anim_zscore: 'pontuação z + percentil',
    acp_hideDetails: 'Ocultar detalhes ▲',
    acp_showDetails: 'Mostrar detalhes ▼',
    acp_moveCloser: 'aproxima-te',
    acp_headLabel: 'Cabeça',
    acp_setupTipsTitle: 'Dicas Rápidas de Configuração',
    acp_tip1: 'Senta-te a ~50 cm (comprimento do braço) do ecrã',
    acp_tip2: 'Assegura uma iluminação uniforme e brilhante no rosto',
    acp_tip3: 'Mantém a cabeça direita e olha diretamente para a câmara',
    acp_tip4: 'Usa um espaço sossegado para uma avaliação sem distrações',
    acp_progressLabel: 'Progresso',

    priv_gdprTitle: 'Conforme com o GDPR',
    priv_gdpr1: 'Consentimento parental verificável para utilizadores com menos de 13 anos',
    priv_gdpr2: 'Minimização de dados e limitação de finalidade',
    priv_gdpr3: 'Direito de acesso, retificação e eliminação de dados',
    priv_gdpr4: 'Tratamento transparente de dados',
    priv_mdrTitle: 'Alinhado com o MDR',
    priv_mdr1: 'Proteção adicional para sujeitos vulneráveis',
    priv_mdr2: 'Segurança e desempenho clínicos',
    priv_mdr3: 'Clara distinção entre rastreio e diagnóstico',
    priv_mdr4: 'Tratamento ético de dados de saúde',
    priv_retentionTitle: 'Política de Retenção de Dados',
    priv_12months: '12 Meses',
    priv_12monthsDesc: 'Coordenadas de rastreamento ocular e teclas',
    priv_24months: '24 Meses',
    priv_24monthsDesc: 'Metadados de análise',
    priv_parentsControl: 'Controlo dos Pais',
    priv_deleteAnytime: 'Elimina em qualquer momento',

    mat_headline1: 'EMPATIA HUMANA.',
    mat_headline2: 'PRECISÃO ARTIFICIAL',
    mat_subheadline: 'Combinando experiência vivida com IA de ponta para tornar o rastreio de dislexia',
    mat_subheadlineHighlight: 'acessível a todos',
    mat_whatTitle: 'O QUE FAZEMOS',
    mat_what1: 'Combinamos uma profunda especialização em padrões de leitura disléxica com tecnologia IA avançada. Após anos de investigação sobre como a dislexia afeta a leitura e onde o cérebro tem de trabalhar mais, ensinámos estas perceções a uma IA adaptativa.',
    mat_what2: 'A nossa IA realiza testes inteligentes e multicamada — cada resposta comparada com milhares de padrões de leitura reais. Aprende em tempo real, fazendo as perguntas de acompanhamento certas e captando pistas subtis que os testes tradicionais não detetam.',
    mat_what3: 'Tudo para dar às famílias a clareza de que precisam para dar o próximo passo com confiança.',
    mat_whyTitle: 'PORQUE O FAZEMOS',
    mat_why1: 'Imagina o teu filho a enfrentar os mesmos desafios de leitura que tu um dia enfrentaste — mas agora, sabes que tem um nome: dislexia. Queres respostas, mas o primeiro passo é um teste que custa entre 750 € e 1.800 € — inacessível para muitas famílias.',
    mat_why2: 'Esta realidade parte-nos o coração. Cada criança merece perceber como aprende. Cada pai merece respostas.',
    mat_why3: 'É por isso que estamos aqui — porque perceber a própria mente nunca deveria ser um privilégio. É um direito humano.',
    mat_bgTitle: 'O NOSSO PERCURSO',
    mat_bg1: 'Vivemos a dislexia em primeira mão e passámos mais de 20 anos a especializar-nos em leitura acessível. Combinando esta experiência vivida com IA, construímos uma ferramenta de triagem da dislexia simples, acessível e que muda vidas.',
    mat_bg2: 'A nossa IA não se limita a medir a velocidade de leitura ou contar erros — compreende o como por trás de cada movimento ocular, pausa e recuperação. Analisa os processos cognitivos que tornam a leitura particularmente desafiante.',
    mat_techTitle: 'A NOSSA TECNOLOGIA',
    mat_tech1: 'Ao amplificar estas diferenças subtis, o nosso sistema aprende a distinguir entre dislexia e outros desafios de leitura com precisão extraordinária. Usamos clustering profundo — uma forma avançada de aprendizagem não supervisionada — para reconhecer as características matizadas do cérebro disléxico.',
    mat_tech2: 'Esta abordagem multicamada e com referências cruzadas traz maior certeza do que qualquer método anterior — indo mais fundo e mais longe do que nunca.',
    mat_eyeTitle: 'Rastreamento Ocular',
    mat_eyeText: 'Medimos a estabilidade do olhar, a duração da fixação e o movimento sacádico para revelar como o foco visual muda durante a leitura.',
    mat_kbdTitle: 'Dinâmica do Teclado',
    mat_kbdText: 'O ritmo das teclas, a hesitação e a velocidade de correção expõem desafios de sequenciamento e fonológicos únicos dos perfis disléxicos.',
    mat_ferTitle: 'Reconhecimento de Emoção Facial (FER)',
    mat_ferText: 'Expressões subtis revelam frustração, envolvimento ou alívio — ajudando a nossa IA a sentir a camada emocional por trás do esforço de leitura.',

    footer_about: 'Sobre',
    footer_blog: 'Publicações',
    footer_contact: 'Contacto',
    footer_faq: 'FAQ',
    footer_privacy: 'Privacidade',
    footer_terms: 'Termos de Serviço',
    footer_tagline: 'Rastreio de dislexia baseado em IA usando rastreamento de íris em tempo real, dinâmica de teclado e análise de expressão facial — disponível em 8 línguas, totalmente no browser.',
    footer_productHeading: 'Produto',
    footer_legalHeading: 'Legal',
    footer_mission: 'Construído para tornar o rastreio de dislexia acessível a todos, em todas as línguas.',
    footer_copyright: 'Todos os direitos reservados',
    footer_madeWith: 'Feito com propósito para a consciencialização da dislexia',
    footer_allSystems: 'Todos os sistemas operacionais',

    fp_assessmentBadge: 'Último passo',
    fp_feedbackTitle: 'Partilha uma nota final',
    fp_feedbackDesc: 'O feedback opcional ajuda-nos a melhorar a experiência de avaliação.',
    fp_shareThoughts: 'Partilha os teus pensamentos',
    fp_optional: 'Opcional',
    fp_words: 'Palavras',
    fp_corrections: 'Correções',
    fp_speed: 'Velocidade',
    fp_feedbackPlaceholder: 'Algo foi difícil, pouco claro ou a melhorar?',
    fp_observationNotesTitle: 'Notas de observação (opcional)',
    fp_observationNotesDesc: 'Para o pai/mãe ou supervisor presente durante o teste: qualquer coisa que tenha notado que o ecrã não consegue ver — distração, cansaço, choro, ruído ou qualquer outra coisa que valha a pena registar juntamente com os resultados.',
    fp_observationNotesPlaceholder: 'por ex. "Parecia cansado durante o teste de escrita de palavras" ou "Distraído por um irmão durante a História 1"',
    fp_generatingReport: 'A gerar o teu relatório…',
    fp_submitBtn: 'Concluir e ver relatório',
    fp_skipHint: 'O feedback é opcional. Continua quando estiveres pronto.',
    fp_youNailedIt: 'Avaliação concluída',
    fp_reportGenerated: 'O teu relatório está pronto no painel.',
    fp_copySentTo: 'Detalhes de acesso enviados para',
    fp_welcomeBack: 'Relatório guardado',
    fp_newReportAdded: 'Adicionado aos resultados do teu painel.',
    fp_reportReady: 'O teu relatório está pronto',
    fp_reportSubtitle: 'Análise completa, reprodução de rastreamento ocular e indicadores de dislexia',
    fp_openingReport: 'A abrir o teu relatório…',
    fp_viewMyReport: 'Ver o Meu Relatório',
    fp_signInLater: 'ou inicia sessão mais tarde em',
    fp_saveForAccess: 'Guarda para acesso futuro',
    fp_emailLabel: 'Email',
    fp_passwordLabel: 'Palavra-passe',
    fp_copied: 'Copiado',
    fp_copy: 'Copiar',
    fp_pwUpdated: 'Palavra-passe atualizada com sucesso',
    fp_setCustomPw: 'Define uma palavra-passe personalizada',
    fp_newPwPlaceholder: 'Nova palavra-passe (mín. 4 caracteres)',
    fp_save: 'Guardar',
    fp_cancel: 'Cancelar',
    fp_signInLink: 'Abrir painel →',
    fp2_saving: 'A guardar os teus resultados…',
    fp2_savingSub: 'Demora alguns segundos. Mantém esta página aberta.',
    fp2_allDone: 'Concluído',
    fp2_reportReadySent: 'O relatório está pronto. Enviámos os dados de acesso para',
    fp2_reportReadyReturning: 'O relatório está pronto e foi adicionado ao teu painel.',
    fp2_passwordLine: 'A tua palavra-passe (também no e-mail):',
    fp2_openReport: 'Abrir o relatório',
    fp2_saveFailed: 'Ainda não foi possível guardar os resultados.',
    fp2_saveFailedSub: 'Verifica a ligação à internet e tenta novamente. Mantém esta página aberta.',
    fp2_tryAgain: 'Tentar novamente',
    fp2_sessionTitle: 'Há algo sobre o teste que devamos saber?',
    fp2_sessionOptional: 'Opcional · não altera o resultado',
    fp2_cTired: 'Cansado ou distraído',
    fp2_cCameraMic: 'Problema com a câmara ou o microfone',
    fp2_cNoisy: 'Barulho ou interrupções',
    fp2_cLanguage: 'Não é a primeira língua',
    fp2_cHelped: 'Alguém ajudou com as respostas',
    fp2_cFroze: 'A página bloqueou ou teve de recarregar',
    fp2_saveNotes: 'Guardar notas',
    fp2_notesSaved: 'Notas guardadas',
    fp2_notesFailed: 'Não foi possível guardar as notas. Tenta novamente.',
    fp_parentNote: '👨‍👩‍👧 Uma nota para o encarregado de educação',
    fp_parentNoteDesc: 'A avaliação está concluída. Partilha quaisquer observações sobre como o teu filho se envolveu nas tarefas de hoje (opcional).',
    fp_screeningResult: 'Resultado do Rastreio',
    fp_riskTypical: 'Típico — nenhum indicador significativo',
    fp_riskBorderline: 'Borderline — alguns indicadores presentes',
    fp_riskHighRisk: 'Alto Risco — vários indicadores detetados',
    fp_riskVeryHighRisk: 'Risco Muito Elevado — indicadores fortes em vários domínios',
    fp_confidence: 'Confiança',
    fp_keyFindings: 'Principais Conclusões',
    fp_disclaimer: 'Este é apenas um instrumento de rastreio — não é um diagnóstico clínico. Por favor consulta um psicólogo educacional registado para uma avaliação completa.',
    fp_notAssessed: 'Não avaliado',
    fp_percentile: 'º percentil',
    fp_domainTypical: '✓ Típico',
    fp_domainBorderline: '⚠ Borderline',
    fp_domainHighRisk: '✗ Alto Risco',
    fp_aiReportTitle: 'Relatório Personalizado IA',
    fp_aiGenerating: 'DysTest AI está a gerar o teu relatório personalizado…',
    fp_aiGenerated: 'Gerado pelo DysTest AI · Não é um diagnóstico clínico',
    fp_aiAnalysing: 'A analisar dados de avaliação…',
    fp_strengths: 'Pontos Fortes',
    fp_areasToSupport: 'Áreas a Apoiar',
    fp_noDifficulties: 'Nenhuma dificuldade significativa detetada.',
    fp_eyeTracking: 'Rastreamento ocular:',
    fp_recommendations: 'Recomendações',
    fp_nextStep: 'Próximo passo:',

    pp_title: 'Política de Privacidade',
    pp_bannerTitle: 'A Tua Privacidade é Sagrada',
    pp_bannerDesc: 'Acreditamos que os teus dados pessoais são teus, não nossos para vender. Recolhemos apenas o que é necessário para te fornecer um rastreio preciso de dislexia, e protegemo-lo com segurança líder do setor. Tens sempre o controlo total das tuas informações.',
    pp_contactTitle: 'Perguntas Sobre a Tua Privacidade?',
    pp_contactDesc: 'Estamos comprometidos com a transparência. Se tens perguntas sobre como tratamos os teus dados, estamos aqui para ajudar.',
    pp_privacyInquiries: 'Consultas de Privacidade',
    pp_generalSupport: 'Suporte Geral',
    pp_acknowledgment: 'Ao usar o Serviço DysTest, reconheces que leste e compreendeste esta Política de Privacidade.',

    tos_title: 'Termos de Serviço',
    tos_missionTitle: 'A Nossa Missão',
    tos_missionDesc: 'Compreender a própria mente não deve ser um luxo — é um direito humano. A nossa missão é tornar o rastreio de dislexia acessível, acessível economicamente e preciso para cada família que precisa.',
    tos_contactTitle: 'Perguntas Sobre Estes Termos?',
    tos_contactDesc: 'Estamos aqui para ajudar. Se tens perguntas sobre os nossos Termos de Serviço, não hesites em contactar-nos.',
    tos_acknowledgment: 'Ao usar o Serviço DysTest, reconheces que leste, compreendeste e concordas em ficar vinculado por estes Termos de Serviço.',

    shared_quickNav: 'Navegação Rápida',
    shared_backHome: '← Voltar ao Início',
    shared_effectiveDate: 'Data de Entrada em Vigor: 30 de outubro de 2025',
    shared_lastUpdated: 'Última Atualização: 30 de outubro de 2025',
    shared_footerTagline: 'Tornar o teste de dislexia preciso, acessível e económico.',
    shared_website: 'Website',
    shared_email: 'Email',

    blog_knowledgeBadge: 'Centro de Conhecimento DysTest',
    blog_title: 'Blog DysTest',
    blog_subtitle: 'Informações especializadas sobre dislexia, diferenças de aprendizagem e como a IA está a revolucionar a deteção precoce e o apoio',
    blog_searchPlaceholder: 'Procura artigos sobre dislexia, diferenças de aprendizagem, avaliação IA...',
    blog_catAll: 'Todos',
    blog_catUnderstanding: 'Compreender a Dislexia',
    blog_catEarlyDetection: 'Deteção Precoce',
    blog_catTechnology: 'Tecnologia',
    blog_catNews: 'Notícias',
    blog_featuredBadge: '⭐ Em Destaque',
    blog_featuredArticles: 'Artigos em Destaque',
    blog_allArticles: 'Todos os Artigos',
    blog_article: 'artigo',
    blog_articles: 'artigos',
    blog_readMore: 'Ler mais →',
    blog_found: 'Encontrados',
    blog_forQuery: 'para',
    blog_noResults: 'Nenhum artigo encontrado',
    blog_noResultsDesc: 'Tenta ajustar os critérios de pesquisa ou filtro',
    blog_clearFilters: 'Limpar filtros e mostrar todos os artigos',
    blog_newsletterTitle: 'Mantém-te Atualizado sobre Investigação em Dislexia',
    blog_newsletterDesc: 'Recebe as últimas informações sobre investigação em dislexia, tecnologia IA e estratégias de aprendizagem diretamente na tua caixa de entrada.',
    blog_newsletterBtn: 'Subscreve as Atualizações',
    blog_newsletterPrivacy: 'Sem spam. Cancela a subscrição em qualquer momento. Respeitamos a tua privacidade.',
    blog_newsletterEmailPlaceholder: 'Introduz o teu email',
    blog_newsletterSending: 'A enviar…',
    blog_newsletterCheckInbox: 'Quase pronto: veja a sua caixa de correio e clique no link para confirmar.',
    blog_newsletterError: 'Algo correu mal. Tente novamente mais tarde.',
    nws_working: 'Um momento…',
    nws_confirmedTitle: 'Está subscrito',
    nws_confirmedBody: 'Obrigado! Vai receber novos artigos do blogue, documentos técnicos e a nossa newsletter. Cada e-mail tem um link para cancelar a subscrição.',
    nws_wasUnsubscribed: 'Este endereço cancelou a subscrição. Subscreva novamente no blogue para receber novidades.',
    nws_unsubTitle: 'Cancelar a subscrição das novidades da DysTest?',
    nws_unsubBody: 'Deixará de receber novos artigos do blogue, documentos técnicos ou a newsletter.',
    nws_unsubBtn: 'Cancelar subscrição',
    nws_unsubDoneTitle: 'Subscrição cancelada',
    nws_unsubDoneBody: 'Não vai receber mais novidades. Mudou de ideias? Pode subscrever novamente no blogue.',
    nws_invalidTitle: 'Este link não é válido',
    nws_invalidBody: 'O link pode ser antigo ou estar incompleto. Pode subscrever novamente no blogue.',
    nws_toBlog: 'Ir para o blogue',
    blog_backToArticles: 'Voltar aos Artigos',
    blog_loadingArticle: 'A carregar artigo...',
    blog_articleNotFound: 'Artigo Não Encontrado',
    blog_ctaTitle: 'Pronto para Saber Mais?',
    blog_ctaDesc: 'Descobre como a DysTest pode ajudar a identificar diferenças de aprendizagem e desbloquear o potencial de cada criança com a nossa avaliação baseada em IA.',
    blog_tryDystest: 'Experimenta a Avaliação DysTest',
    blog_readMoreArticles: 'Ler Mais Artigos',

    faq_badge: 'Tens Perguntas? Temos Respostas',
    faq_title: 'Perguntas Frequentes',
    faq_subtitle: 'Tudo o que precisas saber sobre o nosso',
    faq_subtitleHighlight: 'Rastreio de Dislexia com Rastreamento Ocular',
    faq_searchPlaceholder: "Pesquisa perguntas... (ex. 'custo', 'privacidade', 'quanto tempo')",
    faq_mostPopular: 'Perguntas Mais Populares',
    faq_noResults: 'Nenhuma pergunta encontrada correspondente à tua pesquisa.',
    faq_clearFilters: 'Limpar Filtros',
    faq_stillHave: 'Ainda tens perguntas?',
    faq_supportDesc: 'A nossa equipa de suporte está aqui para te ajudar a encontrar as respostas de que precisas. Normalmente respondemos dentro de 24 horas.',
    faq_contactSupport: 'Contactar Suporte',
    faq_startScreening: 'Iniciar Rastreio',
    faq_catAll: 'Todos',
    faq_related: 'Relacionados:',

    about_badge: 'A Nossa História',
    about_title: 'Sobre a DysTest',
    about_subtitle: 'Acreditamos que cada criança merece ser compreendida — não apenas testada.',
    about_backHome: '← Voltar ao Início',
    about_ctaTitle: 'Pronto para Começar?',
    about_ctaDesc: 'Inicia hoje um rastreio compassivo para o teu filho e descobre como a DysTest ajuda a desbloquear o potencial de cada estudante.',
    about_startScreening: 'Iniciar Rastreio',
    about_startAssessment: 'Começar',
    about_navWhy: 'Porque Existe a DysTest',
    about_navMissionValues: 'Missão e Valores',
    about_navTechnology: 'Tecnologia',
    about_navTeam: 'As Pessoas Por Trás da DysTest',

    ran_audio_preLetter: 'Nomeação de letras. Lê em voz alta cada linha de letras, o mais rápido que conseguires.',
    ran_audio_preDigit: 'Agora os algarismos. Lê em voz alta cada linha de números, o mais rápido que conseguires.',
    ran_audio_preColor: 'Agora as cores. Diz a cor de cada quadrado em voz alta, o mais rápido que conseguires.',
    ran_audio_preObject: 'Agora os objetos. Nomeia cada imagem em voz alta, o mais rápido que conseguires.',
    ran_audio_runLetter: 'Lê cada letra em voz alta o mais rápido que conseguires.',
    ran_audio_runDigit: 'Lê cada número em voz alta o mais rápido que conseguires.',
    ran_audio_runColor: 'Diz a cor de cada quadrado em voz alta o mais rápido que conseguires.',
    ran_audio_runObject: 'Nomeia cada imagem em voz alta o mais rápido que conseguires.',
    ran_audio_practice: 'Vamos praticar. Diz cada letra em voz alta.',
    ran_intro_t1_heading: 'Vamos dizer algumas letras! 🔤',
    ran_intro_t1_desc1: 'Vais ver letras grandes no ecrã.',
    ran_intro_t1_desc2: 'Diz cada uma em voz alta o mais rápido que conseguires!',
    ran_intro_heading: 'RAN',
    ran_intro_desc1: 'Vais ver linhas de letras, algarismos, cores e objetos. Lê cada linha em voz alta o mais rápido que conseguires — da esquerda para a direita.',
    ran_intro_desc2: 'O avaliador pressionará Linha seguinte depois de terminares cada linha. Vamos fazer primeiro uma pequena prática.',
    ran_intro_labLetters: 'Letras',
    ran_intro_labDigits: 'Algarismos',
    ran_intro_labColors: 'Cores',
    ran_intro_labObjects: 'Objetos',
    ran_practice_t1_heading: 'Consegues dizer estas? 👀',
    ran_practice_heading: 'Prática',
    ran_practice_t1_desc: 'Diz cada letra em voz alta. Começa pela esquerda!',
    ran_practice_desc: 'Lê esta linha de letras em voz alta, da esquerda para a direita. O avaliador toca em Linha seguinte quando terminares.',
    ran_practice_hint: 'Diz: "a · o · s · p · k" — depois toca no botão abaixo.',
    ran_btn_try: 'Vamos tentar! 🎉',
    ran_btn_practise: 'Vamos praticar',
    ran_btn_skip: 'Saltar',
    ran_btn_gotIt: 'Entendido — começar as letras →',
    ran_btn_begin: 'Começar — lê a linha 1 →',
    ran_btn_nextRow: 'Linha seguinte',
    ran_btn_continue: 'Continuar',
    ran_preLetter_title: 'Nomeação de letras (RAN-L)',
    ran_preLetter_subtitle: '50 letras · 5 linhas de 10. Lê cada linha em voz alta o mais rápido que conseguires.',
    ran_preLetter_detail: 'O avaliador tocará em Linha seguinte após cada linha.',
    ran_preLetter_btn: 'Mostrar a grelha →',
    ran_preDigit_title: 'Letras concluídas! Agora os algarismos (RAN-D)',
    ran_preDigit_subtitle: 'Agora a mesma tarefa com algarismos: 2 · 4 · 5 · 7 · 8',
    ran_preDigit_detail: '50 algarismos · 5 linhas de 10 · mesmas regras.',
    ran_preDigit_btn: 'Começar algarismos →',
    ran_preColor_title: 'Algarismos concluídos! Agora as cores (RAN-C)',
    ran_preColor_subtitle: 'Diz a cor de cada quadrado em voz alta, o mais rápido que conseguires.',
    ran_preColor_detail: '50 quadrados coloridos · 5 linhas de 10 · mesmas regras.',
    ran_preColor_btn: 'Começar cores →',
    ran_preObject_title: 'Cores concluídas! Agora os objetos (RAN-O)',
    ran_preObject_subtitle: 'Nomeia cada imagem em voz alta, o mais rápido que conseguires.',
    ran_preObject_detail: '50 objetos · 5 linhas de 10 · mesmas regras.',
    ran_preObject_btn: 'Começar objetos →',
    ran_done_t1_heading: 'Trabalho incrível! 🌟',
    ran_done_heading: 'Todas as tarefas de nomeação concluídas!',
    ran_done_t1_desc: 'Disseste todas as letras!',
    ran_done_desc: 'Aqui estão os resultados:',
    ran_badge: 'Teste de Nomeação Rápida',
    ran_intro_watchDemo: '👀 Vê como funciona',
    ran_intro_t1_lead: 'Olha para cada letra e diz-a em voz alta o mais rápido que conseguires — da esquerda para a direita!',
    ran_intro_step1: 'Olha para a linha',
    ran_intro_step2: 'Diz cada uma em voz alta',
    ran_intro_step3: 'Vai o mais rápido que conseguires!',
    ran_intro_demoLabel: 'Diz cada elemento em voz alta, o mais rápido que conseguires!',
    ran_btn_start: 'Começar 🚀',
    ran_btn_tapStart: 'Clica para Começar a Linha 1',
    ran_btn_listening: 'A ouvir…',
    ran_btn_repeat: 'Repetir instrução',
    ran_processing: 'A processar…',
    ran_transcribing: 'A transcrever áudio com Whisper…',
    ran_transcribingDesc: 'A analisar precisão de fala — demora alguns segundos',
    ran_stat_totalTime: 'Tempo total',
    ran_stat_itemsPerSec: 'Itens/s',
    ran_stat_avgItem: 'Item médio',
    ran_stat_mistakes: 'Erros',
    ran_paceHint: 'Realçado = linha atual · O avaliador controla o ritmo',
    ran_running_letter: '🔤 RAN-L — Letras',
    ran_running_digit: '🔢 RAN-D — Números',
    ran_running_color: '🎨 RAN-C — Cores',
    ran_running_object: '🦎 RAN-O — Objetos',
    ran_header_letter: 'RAN-L',
    ran_header_digit: 'RAN-D',
    ran_header_color: 'RAN-C',
    ran_header_object: 'RAN-O',

    nav_home: 'Início',
    nav_about: 'Sobre',
    nav_resources: 'Recursos',
    nav_startAssessment: 'Iniciar avaliação',
    nav_langMenuTitle: 'Idioma da avaliação',
    nav_langMenuHint: 'As histórias e as instruções seguem este idioma',
    nav_techPapers: 'Artigos Técnicos',
    nav_blog: 'Blog',
    nav_guides: 'Guias',
    nav_faq: 'FAQ',

        wwt_badge: 'Teste de escrita de palavras',
    wwt_introTitle: 'Lembre-se e digite a palavra',
    wwt_introDesc: 'Uma palavra aparece por 5 segundos — depois se apaga letra por letra e você a digita de memória',
    wwt_demoHint: 'A palavra desaparece — você a digita de memória',
    wwt_startWriting: 'Comece a escrever!',
    wwt_rememberWord: 'Memoriza esta palavra',
    wwt_watchCountdown: 'Vê a contagem decrescente — depois escreve de memória',
    wwt_typeWord: 'Escreve a palavra que viste',
    wwt_pressEnter: 'Escreve e prime Enter ou Próximo',
    wwt_nextWord: 'Próxima palavra',
    wwt_finish: 'Terminar',
    wwt_done: 'Muito bem!',
    wwt_correct: 'palavras corretas',
    wwt_continue: 'Continuar',
    wwt_wordOf: 'Palavra {current} de {total}',
    form_badgeText: 'Passo 1/8: Registo',
    form_heading: 'Regista-te e Começa',
    form_privacyNote: 'Os teus dados são protegidos pelas regulamentações GDPR e MDR. Nenhuma informação pessoal identificável é partilhada com terceiros.',

    // ── Microphone check panel (mic_*) ───────────────────────────────────
    mic_title: 'Verificação do microfone',
    mic_sub_checking: 'A verificar o microfone…',
    mic_sub_ready: 'Microfone pronto — toca em Testar para gravar',
    mic_sub_recording: 'A gravar… fala agora',
    mic_sub_retry: 'Não conseguimos ouvir bem — tenta novamente',
    mic_sub_passed: 'O microfone está a funcionar perfeitamente!',
    mic_sub_denied: 'Acesso ao microfone negado',
    mic_pleaseSpeak: '🗣️ Por favor, fala agora…',
    mic_retryBody: 'Não conseguimos ouvir-te claramente. Fala um pouco mais alto e tenta novamente.',
    mic_testBtn: 'Testar microfone',
    mic_tryAgain: 'Tentar novamente',
    mic_continueBtn: 'Continuar',
    mic_skipDenied: 'Ignorar (sem microfone)',
    mic_skip: 'Ignorar verificação do microfone',
    ud_myDashboard: 'Meu painel',
    ud_myAssessmentReports: 'Meus relatórios de avaliação',
    ud_noAssessmentsFound: 'Nenhuma avaliação concluída encontrada.',
    ud_assessmentsFoundSingular: '1 avaliação concluída encontrada.',
    ud_assessmentsFoundPlural: '{n} avaliações concluídas encontradas.',
    ud_loadError: 'Não foi possível carregar suas avaliações. Verifique sua conexão e atualize a página.',
    ud_serviceUnavailable: 'O servidor está temporariamente indisponível (503). Por favor, aguarde um momento e atualize a página.',
    ud_progressOverTime: 'Progresso ao longo do tempo',
    ud_longitudinalSubtitle: '{n} avaliações · tendência do escore z composto',
    ud_typical: 'Típico (z ≥ −0,5)',
    ud_borderline: 'Limítrofe (z < −0,5)',
    ud_highRisk: 'Alto risco (z < −1,0)',
    ud_veryHighRisk: 'Risco muito alto (z < −1,5)',
    ud_noAssessmentsFor: 'Nenhuma avaliação encontrada para',
    ud_completeAssessment: 'Conclua uma avaliação para ver seus resultados aqui.',
    ud_startAssessment: 'Iniciar uma avaliação',
    ud_assessmentReport: 'Relatório de avaliação',
    ud_completed: 'Concluído',
    ud_accuracy: 'PRECISÃO',
    ud_blinks: 'PISCADAS',
    ud_questions: 'PERGUNTAS',
    ud_rawData: 'Dados brutos (JSON)',
    ud_tabEyeTracking: 'Rastreamento ocular',
    ud_tabRan: 'Análise RAN',
    ud_tabStory: 'Análise de histórias',
    ud_gazePlaybackTitle: 'Reprodução de rastreamento ocular — 3 modos: Grade · Mapa de calor · Caminho',
    ud_noGazeData: 'Nenhum dado de rastreamento ocular disponível para esta avaliação.',
    ud_gazeDataNote: 'Os dados de rastreamento ocular são capturados durante a sessão de avaliação ao vivo e armazenados com o relatório.',
    ud_ranTitle: 'RAN — Resultados de nomeação automatizada rápida',
    ud_totalTime: 'Tempo total',
    ud_rawSpeed: 'Velocidade bruta',
    ud_correctedSpeed: 'Velocidade corrigida',
    ud_errors: 'Erros',
    ud_rowTimings: 'Tempos por linha',
    ud_transcriptComparison: 'Comparação de transcrição',
    ud_row: 'Linha',
    ud_audioNote: 'A reprodução de áudio está disponível no relatório ZIP completo · Baixar relatório completo (ZIP) acima',
    ud_storyTitle: 'Análise de leitura de história',
    ud_story1Label: 'História 1 — Fase de leitura',
    ud_story2Label: 'História 2 — Fase de leitura',
    ud_readingTime: 'Tempo de leitura',
    ud_fixations: 'Fixações',
    ud_regressions: 'Regressões',
    ud_avgFixation: 'Fix. média',
    ud_saccades: 'Sacadas',
    ud_blinkRate: 'Taxa de piscadas',
    ud_gazeStoryTitle: 'Rastreamento ocular — Páginas de história',
    ud_noStoryGaze: 'Dados de rastreamento ocular de história não disponíveis para esta avaliação.',
    ud_footer: 'Seus dados são armazenados com segurança somente neste dispositivo.',
    ud_changePassword: 'Alterar senha',
    ud_changePasswordDesc: 'Defina uma nova senha para sua conta. Você a usará na próxima vez que entrar.',
    ud_passwordUpdated: 'Senha atualizada com sucesso',
    ud_newPasswordPlaceholder: 'Nova senha (mín. 4 caracteres)',
    ud_saving: 'Salvando…',
    ud_saveNewPassword: 'Salvar nova senha',
    ud_passwordTooShort: 'A senha deve ter pelo menos 4 caracteres.',
    ud_passwordUpdateFailed: 'Não foi possível atualizar sua senha. Por favor, tente novamente.',
    ud_accuracySuffix: 'precisão',
    acp_tabCamera: 'Câmera',
    acp_tabKeyboard: 'Teclado',
    acp_tabMicrophone: 'Microfone',
    acp_checkingCameraQuality: 'Verificando a qualidade da câmera — isso leva alguns segundos',
    acp_allChecksPassed: 'Todas as verificações passaram!',
    acp_allSystemsReady: 'Câmera, teclado e microfone estão prontos.',
    mini_step: 'Passo',
    scp_setupComplete: '🎉 Configuração concluída!',
    scp_allSetSubtitle: 'Você está pronto para a avaliação de dislexia',
    scp_setupQualityScore: 'Pontuação de qualidade da configuração',
    scp_excellentSetup: 'Excelente qualidade de configuração para avaliação precisa',
    scp_completedSteps: '✅ Etapas concluídas',
    scp_cameraReadiness: 'Prontidão da câmera',
    scp_cameraStabilityPassed: 'Verificação de estabilidade de 10 segundos aprovada',
    scp_keyboardCapture: 'Captura do teclado',
    scp_keystrokeData: 'Dados clínicos de pressionamento de teclas capturados',
    scp_eyeCalibration: 'Calibração ocular',
    scp_calibrationCompleted: 'Calibração concluída ({pct}% de precisão)',
    scp_whatsNext: 'O que vem a seguir?',
    scp_whatsNextBody: 'Você iniciará a avaliação de leitura onde analisaremos seus movimentos oculares, expressões faciais e padrões de leitura para fornecer uma triagem abrangente de dislexia.',
    scp_startAssessment: 'Iniciar avaliação de dislexia',
    scp_startingAssessment: 'Iniciando avaliação...',
    scp_estimatedTime: 'Tempo estimado: 10-15 minutos',

    // Grelha de relatórios UserDashboard
    ud_view: 'Ver',
    ud_report_userInfo: 'Informação do utilizador',
    ud_report_envSetup: 'Configuração do ambiente',
    ud_report_wordIcon: 'Correspondência palavra-ícone',
    ud_report_ran: 'Análise RAN',
    ud_report_story: 'Análise de história',
    ud_report_wordWriting: 'Escrita de palavras',
    ud_report_feedback: 'Comentários',
    ud_report_summary: 'Resumo',
    ul_platform: 'Plataforma de avaliação de dislexia',
    ul_invalidCredentials: 'Email ou palavra-passe inválidos. Verifique as credenciais mostradas no fim da sua avaliação.',
    ul_loginFailed: 'Falha ao iniciar sessão. Tente novamente.',
    ul_resetFailed: 'Algo correu mal. Tente novamente.',
    ul_backToSignIn: 'Voltar ao início de sessão',
    ul_checkEmail: 'Verifique o seu email',
    ul_smtpDevNotice: 'SMTP não configurado (dev). Palavra-passe temporária:',
    ul_resetSent: 'Se {email} estiver registado, uma nova palavra-passe está a caminho.',
    ul_signIn: 'Iniciar sessão',
    ul_resetPassword: 'Repor palavra-passe',
    ul_resetPasswordDesc: 'Introduza o seu email e enviaremos uma nova palavra-passe.',
    ul_emailAddress: 'Endereço de email',
    ul_emailPlaceholder: 'seu@email.com',
    ul_sending: 'A enviar…',
    ul_sendNewPassword: 'Enviar nova palavra-passe',
    ul_welcomeBack: 'Bem-vindo de volta',
    ul_signInSubtitle: 'Inicie sessão para ver os seus resultados de avaliação',
    ul_password: 'Palavra-passe',
    ul_passwordPlaceholder: 'A sua palavra-passe',
    ul_hidePassword: 'Ocultar palavra-passe',
    ul_showPassword: 'Mostrar palavra-passe',
    ul_forgotPassword: 'Esqueceu-se da palavra-passe?',
    ul_signingIn: 'A iniciar sessão…',
    ul_signInDashboard: 'Entrar no seu painel',
    ul_firstTime: 'Primeira vez aqui? A sua conta foi criada automaticamente após a avaliação. Verifique o email para os dados de acesso.',
    ul_footer: 'Conforme RGPD e MDR · Nenhum vídeo armazenado',

    mg_title: 'Um pouco de paciência, pela ciência!',
    mg_body: 'O DysTest analisa os movimentos dos teus olhos (ao píxel!), a tua velocidade de escrita e a tua voz ao milissegundo.\n\nUma tecnologia superinteligente, mas tem um ponto fraco: não funciona enquanto o ecrã abana na tua mão. Por isso, abre um portátil ou computador para um resultado fiável!',
    mg_howTo: 'Como começar',
    mg_step1: 'Abra dystest.com num portátil ou computador de secretária',
    mg_step2: 'Confirme que a webcam e o teclado estão ligados',
    mg_step3: 'Use o Chrome ou o Firefox para melhores resultados',
    mg_returnHome: 'Voltar à página inicial',
    mg_shareLink: 'Enviar-me o link',
    mg_copyLink: 'Copiar link',
    mg_linkCopied: 'Link copiado',
    mg_alreadyDone: 'Já fez um teste?',
    mg_loginLink: 'Inicie sessão para ver o relatório',
    mg_emailLabel: 'O seu e-mail',
    mg_emailPlaceholder: 'nome@exemplo.pt',
    mg_emailSend: 'Enviar',
    mg_emailSent: 'Enviado! Abra o e-mail no portátil ou computador para começar o teste.',
    mg_emailError: 'Não foi possível enviar o e-mail. Verifique o endereço e tente novamente.',
};

export default pt;
